<template>
  <section class="flex flex-col">
    <div class="relative">
      <div @click="setRoute('main')" class="flex absolute top-22.5 left-4.5">
        <svg class="mr-5 transform rotate-90 w-3" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 6L7 12L13 6" stroke="#323749" stroke-linejoin="round" />
          <path d="M6.99998 0V12" stroke="#323749" stroke-linejoin="round" />
        </svg>
        <p class="uppercase font-medium fz-10" style="letter-spacing: 0.1rem; color:rgba(110, 117, 141, 1) ">
          {{ text.home }}</p>
      </div>
      <div
        class="video relative top-9.375 w-112.5 transform -translate-x-1/2 left-1/2"
        style="z-index: -10"
      >
        <video
          style="-webkit-mask-image:radial-gradient(circle at center,#000 33%,transparent 70%);"
          class="w-112.5 relative"
          autoplay
          loop
          muted
          src="@/assets/videos/projects.mp4"
        ></video>

      </div>
    </div>


    <div class="flex flex-col mx-4.5 ">
      <div class="header flex items-center justify-between">
        <p class="fz-18 font-medium uppercase" style="line-height: 1.666;color: rgba(50, 55, 73, 1)">/ {{ text.projects
          }}</p>
        <img class="h-10 w-10" src="@/assets/images/box.svg" alt="">
      </div>
      <p class="mt-14 text-justify fz-16 font-medium" style="line-height: 1.875;">{{ text.bigExp }}</p>
    </div>
    <div class="flex flex-col my-25 gap-25">
      <div
        class="w-screen flex flex-col projects"
        v-for="(item, index) in projectsText.projects"
        :class="{'active-slide': index === 0}"
        :key="index"
      >
        <div class="relative">
          <img
            src="@/assets/images/eye-circle.svg"
            @click="setProject(item.id)"
            class="w-12 h-12 absolute left-4 z-20 cursor-pointer top-71.75"
            alt=""
          />
          <img
            src="@/assets/images/arrow-down-circle.svg"
            class="w-12 h-12 absolute left-18.5 z-20 cursor-pointer top-71.75 "
            alt=""
          />
          <img :src="require('@/assets/images/projects/' + item.id + '/' + item.preview + '-m.png')" class="client-list-item w-screen"
               alt="">
        </div>

        <h5 class="mt-7.5 mb-2.5 relative fz-22 mx-4.5" style=" line-height: 1.36;">{{ item.name }}</h5>
        <p class="fz-18 font-medium text-white mx-4.5" style="line-height: 1.666;">{{ item.description }}</p>
      </div>
    </div>
    <slide7 @openContact="toggleContacts" />
  </section>
</template>

<script>
import slide7 from "@/components/mobile/main/slide7";
import { mapMutations, mapState } from "vuex";

export default {
  name: "Projects",
  components: {
    slide7
  },
  computed: {
    ...mapState(["lang"]),
    text() {
      return {
        ...require("@/assets/text/fixWrappers/" + this.lang + ".json"),
        ...require("@/assets/text/projects/slide1/" + this.lang + ".json"),
        ...require("@/assets/text/projects/slide2/" + this.lang + ".json"),
        ...require("@/assets/text/reuseable/last/" + this.lang + ".json")
      };
    },
    projectsText(){
      return require("@/assets/text/project/" + this.lang + ".json")
    }
  },
  methods: {
    ...mapMutations(["toggleContacts", "setRoute", "setProject"])
  }
};
</script>

<style scoped lang="scss">
.projects {
  h5 {
    left: 0;
    color: #FF2E53;
    font-size: 1.375rem;
  }
}

</style>
